// extracted by mini-css-extract-plugin
export var addToCartButton = "_of-b";
export var arrowButtonContainer = "_of-9";
export var arrowButtonIcon = "_of-a";
export var carouselArrowButton = "_of-6";
export var carouselElementContainer = "_of-1";
export var galleryThumbnail = "_of-d";
export var galleryThumbnailImage = "_of-e";
export var left = "_of-7";
export var productDisplayCarouselContainer = "_of-0";
export var productTileContainer = "_of-2";
export var productTileImage = "_of-4";
export var productTileImageContainer = "_of-3";
export var productTileTitle = "_of-5";
export var right = "_of-8";
export var sliderOverflow = "_of-c";